import script from "./UpdateBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateBanner.vue?vue&type=script&setup=true&lang=js"

import "./UpdateBanner.vue?vue&type=style&index=0&id=f4783a8e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4783a8e"]])

export default __exports__